import VueRouter from 'vue-router';

function lazy(view) {
    return () => import(`./${view}.vue`);
}

const routes = [
    {
        name: 'questionsprofils',
        path: '/questionsprofils',
        component: lazy('QuestionsProfils')
    },
    {
        name: 'projetnonidentifie',
        path: '/projetnonidentifie',
        component: lazy('ProjetNonIdentifie')
    },
    {
        name: 'adapteraction',
        path: '/adapteraction',
        component: lazy('competencestransversales/AdapterAction')
    },
    {
        name: 'realiseractivite',
        path: '/realiseractivite',
        component: lazy('competencestransversales/RealiserActivite')
    },
    {
        name: 'construireparcours',
        path: '/construireparcours',
        component: lazy('competencestransversales/ConstruireParcours')
    },
    {
        name: 'apprendreseformer',
        path: '/apprendreseformer',
        component: lazy('competencestransversales/ApprendreSeFormer')
    },
    {
        name: 'travaillerequipe',
        path: '/travaillerequipe',
        component: lazy('competencestransversales/TravaillerEquipe')
    },
    {
        name: 'utilisercodessociaux',
        path: '/utilisercodessociaux',
        component: lazy('competencestransversales/UtiliserCodesSociaux')
    },
    {
        name: 'organiseractivite',
        path: '/organiseractivite',
        component: lazy('competencestransversales/OrganiserActivite')
    },
    {
        name: 'gererinformations',
        path: '/gererinformations',
        component: lazy('competencestransversales/GererInformations')
    },
    {
        name: 'utiliseroutilsnumeriques',
        path: '/utiliseroutilsnumeriques',
        component: lazy('competencestransversales/UtiliserOutilsNumeriques')
    },
    {
        name: 'mobiliserraisonnements',
        path: '/mobiliserraisonnements',
        component: lazy('competencestransversales/MobiliserRaisonnements')
    },
    {
        name: 'communiquerecrit',
        path: '/communiquerecrit',
        component: lazy('competencestransversales/CommuniquerEcrit')
    },
    {
        name: 'communiqueroral',
        path: '/communiqueroral',
        component: lazy('competencestransversales/CommuniquerOral')
    },
    {
        name: 'activitesquotidiennes',
        path: '/activitesquotidiennes',
        component: lazy('questionnairesprofils/ActivitesQuotidiennes')
    }, {
        name: 'maniereapprendre',
        path: '/maniereapprendre',
        component: lazy('questionnairesprofils/ManiereApprendre')
    }, {
        name: 'preferencesengagementformation',
        path: '/preferencesengagementformation',
        component: lazy('questionnairesprofils/PreferencesEngagementFormation')
    }, {
        name: 'preferencesformations',
        path: '/preferencesformations',
        component: lazy('questionnairesprofils/PreferencesFormations')
    }, {
        name: 'agentpublic',
        path: '/agentpublic',
        component: lazy('statuts/AgentPublic')
    }, {
        name: 'agentpublicfinancement',
        path: '/agentpublicfinancement',
        component: lazy('statuts/AgentPublicFinancement')
    }, {
        name: 'autresituation',
        path: '/autresituation',
        component: lazy('statuts/AutreSituation')
    }, {
        name: 'autresituationfinancement',
        path: '/autresituationfinancement',
        component: lazy('statuts/AutreSituationFinancement')
    }, {
        name: 'rechercheemploi',
        path: '/rechercheemploi',
        component: lazy('statuts/RechercheEmploi')
    }, {
        name: 'rechercheemploifinancement',
        path: '/rechercheemploifinancement',
        component: lazy('statuts/RechercheEmploiFinancement')
    }, {
        name: 'salariedroitprive',
        path: '/salariedroitprive',
        component: lazy('statuts/SalarieDroitPrive')
    }, {
        name: 'salariedroitprivefinancement',
        path: '/salariedroitprivefinancement',
        component: lazy('statuts/SalarieDroitPriveFinancement')
    }, {
        name: 'accueil',
        path: '/accueil',
        component: lazy('Accueil')
    }, {
        name: 'choixprojet',
        path: '/choixprojet',
        component: lazy('ChoixProjet')
    }, {
        name: 'choixstatut',
        path: '/choixstatut',
        component: lazy('ChoixStatut')
    }, {
        name: 'choixstatutfinancement',
        path: '/choixstatutfinancement',
        component: lazy('ChoixStatutFinancement')
    }, {
        name: 'competencestransversales',
        path: '/competencestransversales',
        component: lazy('CompetencesTransversales')
    }, {
        name: 'confirmation',
        path: '/confirmation',
        component: lazy('Confirmation')
    }, {
        name: 'diplomenonaccessible',
        path: '/diplomenonaccessible',
        component: lazy('DiplomeNonAccessible')
    }, {
        name: 'fin',
        path: '/fin',
        component: lazy('Fin')
    }, {
        name: 'qualificationexperiencediplome',
        path: '/qualificationexperiencediplome',
        component: lazy('QualificationExperienceDiplome')
    }, {
        name: 'rechercheformation',
        path: '/rechercheformation',
        component: lazy('RechercheFormation')
    }, {
        name: 'recueilinfos',
        path: '/recueilinfos',
        component: lazy('RecueilInfos')
    }, {
        path: '/',
        redirect: '/accueil'
    }
];
export default new VueRouter({
    routes,
});